import { observer } from 'src/utils/mobx-react';
import React from 'react';
import { List as MovableList } from 'react-movable';
import { MarketTemplateList, MarketTemplateListItem } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSettings.style';
import { MarketTemplateSelectionSettings } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelectionSettings';
import { MarketTemplateSettingsFormState } from 'src/components/MarketTemplateSettingsForm/MarketTemplateSettingsForm.state';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { MarketTemplateSelectionSettingsNewTrading } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelectionSettingsNewTrading';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';
import { SourceTypeIO } from 'src/components/SportPopup/SportMarketTemplates/MarketTemplates.utills';



const StandardSelectionKeyIO = t.interface({
    namePattern: t.union([t.string, t.undefined, t.null]),
    sourceType: t.record(t.literal('type'), SourceTypeIO),
    metadata: t.record(t.string, t.string)
});

const SelectionsIO = t.array(t.interface({
    type: t.union([t.literal('Manual'), t.literal('Double'), t.literal('Participant'), t.literal('Standard'), t.literal('UnnamedFavourite')]),
    namePattern: t.union([t.string, t.null, t.undefined]),
    metadata: t.record(t.string, t.string),
    autoCreate: t.boolean,
    settings: t.unknown,
    first: t.union([t.undefined, t.null, StandardSelectionKeyIO]),
    second: t.union([t.undefined, t.null, StandardSelectionKeyIO])
}));

type SelectionsNewTradingType = t.TypeOf<typeof SelectionsIO>;
const isSelectionGuard = createGuard(SelectionsIO);
export type SelectionNewTradingType = SelectionsNewTradingType extends Array<infer T> ? T : never;
export function buildSelectionsNewTrading(data: string): SelectionsNewTradingType | undefined {
    const rawData = JSON.parse(data);
    if (isSelectionGuard(rawData)) {
        return rawData;
    }
    console.error('SelectionNewTradingType parse error: ', rawData);
}

type MarketTemplateSelectionsPropsType = {
    marketTemplateSettingsState: MarketTemplateSettingsFormState;
    marketTemplatesState: SportMarketTemplatesState;
}

export const MarketTemplateSelections = observer('MarketTemplateSelections', ({marketTemplateSettingsState, marketTemplatesState}: MarketTemplateSelectionsPropsType) => {
    return (
        <div className='col-4 market-template-settings__selections market-template-settings'>
            <h4>Selections</h4>
            {marketTemplateSettingsState.isNewTradingData ?
                <MovableList
                    values={marketTemplateSettingsState.newTradingSelections}
                    onChange={marketTemplateSettingsState.onChangeSelectionsOrderNewTrading}
                    renderList={({ children, props }) => <MarketTemplateList {...props} >{children}</MarketTemplateList>}
                    renderItem={({ value: selection, props, isDragged}) => {
                        return (<MarketTemplateListItem
                            {...props}
                            className='market-template-settings-form'
                            isDragged = {isDragged}
                            style={{
                                ...props.style
                            }}
                        >
                            <MarketTemplateSelectionSettingsNewTrading
                                {...props}
                                selection={selection}
                                isDragged={isDragged}
                                marketTemplateSettingsState={marketTemplateSettingsState}
                                marketTemplateState={marketTemplatesState}
                            />
                        </MarketTemplateListItem>);
                    }}
                /> :
                <MovableList
                    values={marketTemplateSettingsState.selections ?? []}
                    onChange={marketTemplateSettingsState.onChangeSelectionsOrder}
                    renderList={({ children, props }) => <MarketTemplateList {...props} >{children}</MarketTemplateList>}
                    renderItem={({ value, props, isDragged}) => {
                        return (<MarketTemplateListItem
                            {...props}
                            className='market-template-settings-form'
                            isDragged = {isDragged}
                            style={{
                                ...props.style
                            }}
                        >
                            <MarketTemplateSelectionSettings
                                selection={value}
                                isDragged={isDragged}
                                marketTemplateSettingsState={marketTemplateSettingsState}
                                marketTemplateState={marketTemplatesState}
                            />
                        </MarketTemplateListItem>);
                    }}
                />
            }


            <button
                className='btn btn-add'
                type='button'
                onClick={ marketTemplatesState.onOpenSelectionPopup}
            >
                        Add selection template
            </button>
        </div>
    );
    // }

});
